import { api } from './client.js';

const root = '/admin/customers';

export const customersApi = {
  list: (params) => api.get(root, { query: params }),
  get: (id) => api.get(`${root}/${id}`),
  create: (body) => api.post(root, body),
  update: (id, body) => api.patch(`${root}/${id}`, body),
  remove: (id) => api.delete(`${root}/${id}`),
  invite: (id) => api.post(`${root}/${id}/invite`, {}),
  invites: (id) => api.get(`${root}/${id}/invites`),
  revokeInvite: (id, inviteId) => api.delete(`${root}/${id}/invites/${inviteId}`),
  link: (id, body) => api.post(`${root}/${id}/link`, body)
};
